<template>
  <footer class="footer">
    <div class="columns">
      <div class="column is-one-third">
        <div class="content">
          <h4 class="title is-4">Get in touch:</h4>
          <p>
            Drop me a line if you have questions or just way to say hi. I'd also
            be happy to know if you find any bugs!
          </p>
          <p>Email: dan@thepath.dev</p>
          <p>
            Or go here:
            <a href="https://thepath.dev">thepath.dev</a>
          </p>
        </div>
      </div>
      <div class="column is-one-third"></div>
      <div class="column is-one-third wrapper">
        <div class="badge">
          <figure>
            <a href="https://bulma.io" target="_blank">
              <img
                src="@/assets/made-with-bulma--semiwhite.png"
                alt="Made with Bulma"
                width="256"
                height="48"
              />
            </a>
          </figure>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-centered">
        <div class="content has-text-centered is-small">
          <p>
            <em>
              This site is provided for educational and enteraintment purposes
              only. It does not constitute investment or financial advice.</em
            >
          </p>
        </div>
      </div>
    </div>
    <div class="container is-centered"></div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>

<style scoped>
footer {
  background-color: #3f3f3f;
  color: #fff;
  padding-bottom: 30px;
}
h4 {
  color: #fff;
}
a {
  color: aquamarine;
}
.wrapper {
  position: relative;
}
.badge {
  /* padding-top: 70px; */
  position: absolute;
  bottom: 0;
}
.content {
  padding-top: 20px;
}
</style>